import script from "./BaseFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFooter.vue?vue&type=script&setup=true&lang=ts"

import "./BaseFooter.vue?vue&type=style&index=0&id=0233f7aa&scoped=true&lang=less"
import "./BaseFooter.vue?vue&type=style&index=1&id=0233f7aa&scoped=true&lang=less"

import exportComponent from "/Users/jizhengliang/Desktop/octopus/edu/educms-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0233f7aa"]])

export default __exports__